import {
  CmpTypographyField,
  CmpInputField,
  CmpStatus,
} from "../../../Component/Common/ToolBox/ToolBox";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";

import Grid from "@mui/material/Grid";
export default function WmsFooter({
  vRdxWmsHead,
  fHeadNarration,
  xErrorMsg,
  sFooterObj,
}) {
  return (
    <div className="Wms-footer">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Narration"} />
            </Grid>
            <Grid item xs={10} sm={10} md={4} lg={4}>
              <CmpInputField
                xtabIndex="201"
                xValue={vRdxWmsHead.A_Narr}
                xType={"text"} // text/number/password
                xName={"A_Narr"}
                xReadOnly={false}
                xOnChange={fHeadNarration}
                xError={xErrorMsg.A_Narr === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Narr}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} className="text-center">
              <CmpStatus xStatus={vRdxWmsHead.A_DocStat} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center justify-content-end"
                : "align-items-start justify-content-end"
            }
          >
            <Grid item xs={2} sm={2} md={1.5} lg={1.5}>
              <CmpTypographyField xcomponent={"span"} xText={"Net Value"} />
            </Grid>
            <Grid item xs={10} sm={10} md={4} lg={2}>
              <CmpInputField
                xtabIndex="202"
                xValue={sFooterObj.F_NetValue}
                xType={"text"} // text/number/password
                xName={"F_NetValue"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="Right"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
